import React from 'react';
import { Button, Container } from 'react-bootstrap';


function ContactSignUp() {
    return (
       
                <Container>
                    <div className='row  backgroundContact img-fluid text-white align-items-center mx-auto ' style={{ backgroundImage: `url('../../server-build/Images/HomepageCTA.png')` }} >
                        <div className='col text-center d-none d-lg-block'>
                            <p >Contact</p>
                            <h2 className=' mb-4'>Ready to get started? <br/>Sign up or contact us</h2>
                            <Button href="/Contacts" target='_blank' variant="outline-secondary bg-white" className='rounded-pill text-black fw-bold  ' >Contact Us</Button>
                        </div>
                        <div className='col d-lg-none text-center'>
                            <p>Contact</p>
                            
                            <h2>Ready to get <br /> started? <br />Sign up or<br /> contact us</h2>
                            <Button href="/Contacts" target='_blank' variant="outline-secondary bg-white" className='rounded-pill text-black mt-3 fw-bold'>Contact Us</Button>
                        </div>
                    </div>
                </Container>


        
    );
}

export default ContactSignUp ;
